<main class="main-wrap">
    <div class="middle-wrapper">
      <app-customer-demand-report></app-customer-demand-report>
    </div>
    <div class="right-sidebar-wrapper">
      <app-industry-report-suggestion></app-industry-report-suggestion>
    </div>
  </main>